import {
  SlSpinner
} from "./chunk.R2T2D3TO.js";

// src/components/spinner/spinner.ts
var spinner_default = SlSpinner;
SlSpinner.define("sl-spinner");

export {
  spinner_default
};
